var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsTypeBar"},[(_vm.apiDataBarChart.legend.length==0)?_c('div',{staticClass:"barEmpty"},[_c('img',{attrs:{"src":require("@/assets/images/empty_blue.png")}}),_c('p',[_vm._v("暂无结果")])]):_vm._e(),_c('div',{ref:"bar",staticClass:"bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }